import { render, staticRenderFns } from "./goodsAttr2.vue?vue&type=template&id=5b6f7c77&scoped=true&"
import script from "./goodsAttr2.vue?vue&type=script&lang=js&"
export * from "./goodsAttr2.vue?vue&type=script&lang=js&"
import style0 from "./goodsAttr2.vue?vue&type=style&index=0&id=5b6f7c77&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f7c77",
  null
  
)

export default component.exports